import { render, staticRenderFns } from "./SocialWallLikesModal.vue?vue&type=template&id=3885387c&scoped=true"
import script from "./SocialWallLikesModal.vue?vue&type=script&lang=js"
export * from "./SocialWallLikesModal.vue?vue&type=script&lang=js"
import style0 from "./SocialWallLikesModal.vue?vue&type=style&index=0&id=3885387c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3885387c",
  null
  
)

export default component.exports